@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.verification-icon {
  display: flex;
}

.tooltip-text {
  max-width: 300px;
}

.icon-wrapper {
  height: 30px;
  width: 100%;
  min-width: 20px;
  align-self: center;
}

.icon {
  height: 16px;
  width: 100%;
  vertical-align: middle;
  margin: 0 0 3px 1px;
  color: @product-page--inventory-icon--fill-color;
}
